export enum TypeCancellationModel {
    PERCENTAGE = "percentage",
    AMOUNT = "amount",
}